module.exports = "/templates/login.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/login.html
// module id = 452
// module chunks = 0